import { Input } from "design-react-kit";
import moment from "moment";
import React, { useEffect, useState, useContext } from "react";
import ModalComponent from "../../Components/ModalComponent";
import Repo from "../../Utility/Repo";
import { Link, useLocation, useParams } from "react-router-dom";
import Select from "../../Components/Select";
import { PROVINCE } from "../../Components/listaProvince";
import { NAZIONI } from "../../Components/listaNazioni";
import { TokenContext } from "../../Components/TokenContext";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { useRef } from "react";
import CondizioniAbitativeComponent from "../../Components/CondizioniAbitativeComponent";
import ComponentiNucleoFamiliareComponent from "../../Components/ComponentiNucleoFamiliare";
import InterventiSocioAssistenzialiComponent from "../../Components/InterventiSocioAssistenzialiComponent";
import AnamnesiFamiliariComponent from "../../Components/AnamnesiFamiliariComponent";
import DiarioDiBordoComponent from "../../Components/DiarioDiBordoComponent";
import UserSubscriptionsComponent from "../../Components/UserSubscriptionsComponent";
import StatoCivileSelect from "../../Components/StatoCivileSelect";
import AllegatiUtenteComponent from "../../Components/AllegatiUtenteComponent";
import Loader from "../../Components/Loader";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import EditUser from "./EditUser";
import ListPaymemtsUsers from "../../Components/listPaymentsUser";
import Pagination from "../../Components/Pagination";
import Badge from "../../Components/Badge";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function ViewCartellaSociale(props) {
  const apiToken = useContext(TokenContext);
  const [userSubscriptionsTemp, setUserSubscriptionsTemp] = useState({});

  const [fiscalCode, setFiscalCode] = useState("");

  const [bandiAttivabili, setBandiAttivabili] = useState({});
  const [numberCard, setNumberCard] = useState(0);

  const [selectedStatoCivile, setSelectedStatoCivile] = useState(0);
  const [paymentsTemp, setPaymentsTemp] = useState();

  const [user, setUser] = useState({});
  const [payments, setPayments] = useState();

  const handleStatoCivileChange = (event) => {
    setFormData({ ...formData, statoCivile: Number(event.target.value) });
    setSelectedStatoCivile(Number(event.target.value));
  };
  const [userIsees, setUserIsees] = useState();
  const [userIseesTemp, setUserIseesTemp] = useState();

  const [cartellaSociale, setCartellaSociale] = useState({
    userId: "",
    user: {
      id: "",
      firstName: "",
      lastName: "",
      fiscalCode: "",
      birthDate: "",
      email: "",
      emailPec: "",
      phoneNumber: "",
      address: "",
      addressNumber: "",
      cap: "",
      country: "",
      city: "",
      municipioId: null,
      municipio: null,
      nation: "",
      homeAddress: "",
      dataInsert: "",
      state: "",
      isees: [],
    },
    iban: "",
    cittadinanzaItaliana: null,
    altraCittadinanza: null,
    reddito: 0,
    redditoUltimoAggiornamento: null,
    altraCittadinanzaNome: null,
    possessoPermessoSoggiorno: null,
    possessoCartaSoggiorno: null,
    statoCivile: 1,
    statoCivileDescrizione: null,
  });
  const [redditiISEE, setRedditiISEE] = useState({});

  const [condizioniAbitative, setCondizioniAbitative] = useState({});
  const [componenteNucleoFamiliare, setComponenteNucleoFamiliare] = useState(
    {},
  );

  const [
    componenteNucleoFamiliareNonConviventi,
    setComponenteNucleoFamiliareNonConviventi,
  ] = useState({});
  const [
    componenteNucleoFamiliareParente,
    setComponenteNucleoFamiliareParente,
  ] = useState({});

  const [interventiSocioAssistenziali, setInterventiSocioAssistenziali] =
    useState({});
  const [anamnesiFamiliari, setAnamnesiFamiliari] = useState({});
  const [diarioDiBordo, setDiarioDiBordo] = useState({});

  const [loading, setLoading] = useState(false);

  const [isDisabled, setIsDisabled] = useState(true);
  const [listaProvince] = useState(PROVINCE);
  const [listaNazioni] = useState(NAZIONI);

  const ref = useRef();

  let query = useQuery();

  const paramId = query.get("id");

  const [activeTab, setActiveTab] = useState("nav-tab1");

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  const [showModalModify, setshowModalModify] = useState(false);
  const [isOpenAnprLogs, toggleModalAnprLogs] = useState(false);
  const [anprLogs, setAnprLogs] = useState([]);
  const [loadingAnprLogs, setLoadingAnprLogs] = useState(false);
  const [searchMode, setSearchMode] = useState("data");
  const [iseeDate, setIseeDate] = useState("");
  const [protocolloDSU, setProtocolloDSU] = useState("");

  const [error, setError] = useState("");
  const initialFormData = {
    id: "",
    cittadinanzaItaliana: null,
    altraCittadinanza: null,
    possessoPermessoSoggiorno: null,
    possessoCartaSoggiorno: null,
    statoCivile: 0,
    IBAN: "",
    reddito: 0,
    redditoUltimoAggiornamento: null,
  };
  const [formData, setFormData] = useState(initialFormData);

  const toggleModalModify = () => {
    setshowModalModify(!showModalModify);
  };

  const resetFormFields = () => {
    setFormData(initialFormData);
    setError("");
  };

  const handleDelete = (ISEEId) => {
    const confirmDelete = window.confirm(
      `Sei sicuro di voler eliminarel'isee selezionato?`,
    );

    if (confirmDelete) {
      Repo.deleteIsee(apiToken, ISEEId)
        .then((response) => {
          if (response.status === 204) {
            setUserIseesTemp((prevUserIseesTemp) =>
              prevUserIseesTemp.filter((isee) => isee.id !== ISEEId),
            );
          }
        })
        .catch((error) => {
          Repo.handleApiError(error, setError);
        });
    }
  };

  const uploadIsee = (userId) => {
    window.location.href =
      props.subfolder +
      "/lista_utenti/cartella_sociale/caricamento_ISEE_operatore?userId=" +
      userId;
  };

  const importaIseeDaInps = () => {
    if (!iseeDate) {
      alert("Seleziona una data di riferimento");
      return;
    }

    setLoading(true);
    Repo.getIseeFromInps(apiToken, paramId, iseeDate)
      .then((response) => {
        if (response.status === 200) {
          window.location.href =
            props.subfolder +
            "/lista_utenti/cartella_sociale/visualizza_isee?idIsee=" +
            response.data;
        }
      })
      .catch((error) => {
        console.error("Errore recupero ISEE INPS", error);
        alert("Errore nel recupero ISEE da INPS");
      })
      .finally(() => setLoading(false));
  };

  const importaIseeDaInpsByDsu = () => {
    if (!protocolloDSU?.trim()) {
      alert("Inserisci un DSU di riferimento");
      return;
    }

    setLoading(true);
    Repo.getIseeFromInpsDSU(apiToken, paramId, protocolloDSU.trim())
      .then((response) => {
        if (response.status === 200) {
          window.location.href =
            props.subfolder +
            "/lista_utenti/cartella_sociale/visualizza_isee?idIsee=" +
            response.data;
        }
      })
      .catch((error) => {
        console.error("Errore recupero ISEE INPS da protocollo DSU", error);
        alert("Errore nel recupero ISEE da protocollo DSU");
      })
      .finally(() => setLoading(false));
  };

  const handlePrint = () => {
    setLoading(true);
    Repo.creaDocumentoCartellaSociale(apiToken, paramId)
      .then((response) => {
        if (response.status == 200) {
          setLoading(false);
          const base64String = response.data;

          // Decodifica il Base64
          const byteCharacters = atob(base64String);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);

          // Crea un Blob per il file PDF
          const blob = new Blob([byteArray], { type: "application/pdf" });

          // Crea un URL temporaneo per il download
          const url = window.URL.createObjectURL(blob);

          // Crea un link e simula il click per il download
          const a = document.createElement("a");
          a.href = url;
          a.download = "CartellaSociale_" + fiscalCode + ".pdf";
          document.body.appendChild(a);
          a.click();

          // Cleanup: rimuove il link temporaneo
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        }
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  const syncUserFromANPR = async () => {
    if (!apiToken || !fiscalCode) return;

    setLoading(true);
    try {
      await Repo.getANPRIns(apiToken, fiscalCode);
      fetchDataAndPopulateState();
    } catch (error) {
      console.error("Errore sincronizzazione ANPR:", error);
      alert("Errore durante l'aggiornamento da ANPR");
      setLoading(false);
    }
  };

  const openAnprLogs = async () => {
    if (!apiToken || !paramId) return;

    toggleModalAnprLogs(true);
    setLoadingAnprLogs(true);

    try {
      const response = await Repo.getAnprLogs(apiToken, paramId);
      setAnprLogs(response?.data || []);
    } catch (error) {
      console.error("Errore recupero log ANPR:", error);
      setAnprLogs([]);
      alert("Errore durante il recupero dei log ANPR");
    } finally {
      setLoadingAnprLogs(false);
    }
  };

  const anprLogsBody = () => {
    const renderLogValue = (value) => {
      if (!value) return "-";

      const chunks = String(value)
        .split('";"')
        .map((chunk) => chunk.trim())
        .filter((chunk) => chunk.length > 0);

      if (chunks.length === 0) return "-";

      return chunks.map((chunk, index) => (
        <React.Fragment key={index}>
          {index > 0 && <br />}
          {chunk}
        </React.Fragment>
      ));
    };

    if (loadingAnprLogs) {
      return <p>Caricamento log ANPR in corso...</p>;
    }

    if (!anprLogs || anprLogs.length === 0) {
      return <p>Nessuna modifica ANPR registrata per questo utente.</p>;
    }

    return (
      <div className="table-responsive">
        <table
          className="table table-striped table-sm"
          style={{ tableLayout: "fixed", width: "100%" }}
        >
          <colgroup>
            <col style={{ width: "9%" }} />
            <col style={{ width: "10%" }} />
            <col style={{ width: "15%" }} />
            <col style={{ width: "15%" }} />
            <col style={{ width: "12%" }} />
            <col style={{ width: "12%" }} />
          </colgroup>
          <thead>
            <tr>
              <th>Data</th>
              <th>Campo</th>
              <th>Valore precedente</th>
              <th>Nuovo valore</th>
              <th>Operazione</th>
              <th>Update By</th>
            </tr>
          </thead>
          <tbody>
            {anprLogs.map((log) => (
              <tr key={log.id}>
                <td>{log.dataInsert || "-"}</td>
                <td>{log.fieldName || "-"}</td>
                <td>{renderLogValue(log.oldValue)}</td>
                <td>{renderLogValue(log.newValue)}</td>
                <td>{log.operation || "-"}</td>
                <td>{log.updatedByFiscalCode || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  const getPayments = (fiscalCode) => {
    Repo.getListPaymentOperator(apiToken, "", fiscalCode)
      .then((response) => {
        if (response.status == 200) {
          setPaymentsTemp(response.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const showModify = (ogg) => {
    formData.id = ogg.id;
    formData.cittadinanzaItaliana = ogg.cittadinanzaItaliana;
    formData.altraCittadinanza = ogg.altraCittadinanza;
    formData.possessoPermessoSoggiorno = ogg.possessoPermessoSoggiorno;
    formData.possessoCartaSoggiorno = ogg.possessoCartaSoggiorno;
    formData.statoCivile = ogg.statoCivile;
    formData.IBAN = ogg.iban;
    formData.reddito = ogg.reddito;
    formData.redditoUltimoAggiornamento = ogg.redditoUltimoAggiornamento;
    formData.medico = ogg.medico;
    setshowModalModify(true);
  };

  const handleCloseModalModify = () => {
    setshowModalModify(false);
    resetFormFields();
  };

  const handleUpdate = () => {
    Repo.postUpdCartellaSociale(apiToken, paramId, JSON.stringify(formData))
      .then((response) => {
        if (response.status === 204) {
          // onUpdate(formData);
          fetchDataAndPopulateState();
          setshowModalModify(false);
          // Passa i dati aggiornati al genitore
          // onClose();
        }
      })
      .catch((error) => {
        setError(error.response?.data?.Message || error.response?.data || "");
      });
  };

  const handleChangeCheckbox = (property, value) => {
    setFormData({ ...formData, [property]: value });
  };

  //fine nuovo codice

  const bodyModify = () => {
    return (
      <>
        <div className="row">
          <div className="col-lg-12">
            <div className="row">
              <div className="col-2 mt-2">
                <strong>Dott./Dott.ssa</strong>
              </div>
              <div className="col-10">
                <Input
                  id="medico"
                  label="Medico Curante"
                  type="text"
                  name="medico"
                  value={formData && formData.medico ? formData.medico : ""}
                  onChange={(e) =>
                    setFormData({ ...formData, medico: e.target.value })
                  }
                />
              </div>
            </div>
          </div>
          <div className="col-lg-12 mt-2">
            <div className="form-group">
              <Input
                type="text"
                label="IBAN"
                id="IBAN"
                onChange={(e) =>
                  setFormData({ ...formData, IBAN: e.target.value })
                }
                value={formData.IBAN}
              />
            </div>

            <div className="form-group mt-4">
              <label htmlFor="reddito" className="active">
                Reddito
              </label>
              <input
                type="text"
                id="reddito"
                onChange={(e) =>
                  setFormData({ ...formData, reddito: e.target.value })
                }
                value={formData.reddito}
              />
            </div>

            <div className="form-group mt-4">
              <input
                type="hidden"
                id="redditoUltimoAggiornamento"
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    redditoUltimoAggiornamento: e.target.value,
                  })
                }
                value={formData.redditoUltimoAggiornamento}
              />
            </div>

            <div className="select-wrapper">
              <label htmlFor="statoCivile" className="active">
                Stato civile:
              </label>
              <StatoCivileSelect
                onChangeSelect={handleStatoCivileChange}
                selectedValue={formData.statoCivile}
                setStatoCivileForm={setFormData}
              />
            </div>

            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="cittadinanzaItaliana"
                onChange={(e) =>
                  handleChangeCheckbox("cittadinanzaItaliana", e.target.checked)
                }
                checked={formData.cittadinanzaItaliana}
              />
              <label
                className="form-check-label"
                htmlFor="cittadinanzaItaliana"
              >
                Cittadinanza Italiana
              </label>
            </div>

            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="altraCittadinanza"
                onChange={(e) =>
                  handleChangeCheckbox("altraCittadinanza", e.target.checked)
                }
                checked={formData.altraCittadinanza}
              />
              <label className="form-check-label" htmlFor="altraCittadinanza">
                altra Cittadinanza
              </label>
            </div>

            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="possessoPermessoSoggiorno"
                onChange={(e) =>
                  handleChangeCheckbox(
                    "possessoPermessoSoggiorno",
                    e.target.checked,
                  )
                }
                checked={formData.possessoPermessoSoggiorno}
              />
              <label
                className="form-check-label"
                htmlFor="possessoPermessoSoggiorno"
              >
                possesso Permesso Soggiorno
              </label>
            </div>

            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="possessoCartaSoggiorno"
                onChange={(e) =>
                  handleChangeCheckbox(
                    "possessoCartaSoggiorno",
                    e.target.checked,
                  )
                }
                checked={formData.possessoCartaSoggiorno}
              />
              <label
                className="form-check-label"
                htmlFor="possessoCartaSoggiorno"
              >
                possesso Carta Soggiorno
              </label>
            </div>

            <div className="d-flex justify-content-end">
              {!error && (
                <button
                  className="btn btn-primary btn-salva"
                  type="button"
                  onClick={handleUpdate}
                >
                  Modifica
                </button>
              )}
            </div>
            {error && (
              <div className="alert alert-danger mt-2" role="alert">
                <b>Attenzione:</b> {error}.
              </div>
            )}
          </div>
        </div>
      </>
    );
  };

  useEffect(() => {
    if (query.get("id") != null) {
      Repo.getUserOperator(apiToken, query.get("id"))
        .then((response) => {
          setUserIseesTemp(response.data.isees);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      window.location.href = props.subfolder + "/lista_utenti";
    }
  }, []);

  const fetchDataAndPopulateState = () => {
    if (query.get("scroll")) {
      window.scrollTo(0, ref.current.offsetHeight + 150);
    }

    if (paramId) {
      setLoading(true); // Inizia il loading prima delle chiamate asincrone

      // Carica i dati principali della cartella sociale
      Repo.GetCartellaSocialeByUserId(apiToken, paramId)
        .then((response) => {
          setCartellaSociale(response.data);
          setUser(response.data.user);
          setFiscalCode(response.data.user.fiscalCode);
          setRedditiISEE(response.data.redditiISEE);
          setCondizioniAbitative(response.data.condizioniAbitative);
          setComponenteNucleoFamiliare(response.data.componenteNucleoFamiliare);
          setComponenteNucleoFamiliareNonConviventi(
            response.data.componenteNucleoFamiliareNonConviventi,
          );
          getPayments(response.data.user.fiscalCode);
          setComponenteNucleoFamiliareParente(
            response.data.componenteNucleoFamiliareParente,
          );
          setInterventiSocioAssistenziali(
            response.data.interventiSocioAssistenziali,
          );
          setAnamnesiFamiliari(response.data.anamnesiFamiliari);
          setDiarioDiBordo(response.data.diariDiBordo);

          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });

      // Altre chiamate asincrone...
      Promise.all([
        Repo.getSubscriptionUser(apiToken, paramId),
        Repo.getAnnouncementsByServiceOperatorNotUsed(apiToken, paramId),
      ])
        .then(([subscriptionsResponse, announcementsResponse]) => {
          setUserSubscriptionsTemp(subscriptionsResponse.data);
          setBandiAttivabili(announcementsResponse.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  useEffect(() => {
    if (paramId !== undefined && paramId !== null) {
      fetchDataAndPopulateState();
    }
  }, [paramId]);

  return (
    <>
      <div id="contentToPrint">
        <div>
          <h1>
            {user && user.firstName
              ? " " + user.lastName + " " + user.firstName
              : ""}
          </h1>{" "}
          <Badge
            badgeStatus="bg-primary"
            badgeText={user && user.state}
          ></Badge>{" "}
          <div className="col-lg-12 d-flex justify-content-end">
            <div>
              <button
                className="btn btn-outline-primary mr-2"
                type="button"
                title="Aggiorna da ANPR"
                onClick={syncUserFromANPR}
              >
                ANPR
                <svg className="icon icon-sm align-middle icon-primary ml-1">
                  <use href={`${iconSprite}#it-download`} />
                </svg>
              </button>

              <button
                className="btn btn-outline-primary"
                type="button"
                title="Visualizza changelog ANPR"
                onClick={openAnprLogs}
              >
                Changelog
                <svg className="icon icon-sm align-middle icon-primary ml-1">
                  <use href={`${iconSprite}#it-list`} />
                </svg>
              </button>
              <button
                className="btn btn-success ml-2"
                type="button"
                onClick={() => handlePrint()}
              >
                <svg className="icon icon-sm icon-white">
                  <use href={`${iconSprite}#it-print`}></use>
                </svg>
                Cartella Sociale
              </button>
            </div>
          </div>
          <ul className="nav nav-tabs auto mt-3">
            <li className="nav-item">
              <button
                className={`nav-link ${numberCard === 0 ? "active" : ""}`}
                onClick={() => setNumberCard(0)}
              >
                Anagrafica
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${numberCard === 1 ? "active" : ""}`}
                onClick={() => setNumberCard(1)}
              >
                Cartella sociale
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${numberCard === 2 ? "active" : ""}`}
                onClick={() => setNumberCard(2)}
              >
                ISEE
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${numberCard === 3 ? "active" : ""}`}
                onClick={() => setNumberCard(3)}
              >
                Iscrizioni
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${numberCard === 4 ? "active" : ""}`}
                onClick={() => setNumberCard(4)}
              >
                Pagamenti
              </button>
            </li>
          </ul>
          {numberCard === 0 && user && (
            <div className="mt-5">
              <EditUser subfolder={props.subfolder} user={user}></EditUser>
            </div>
          )}
          {numberCard === 1 && (
            <>
              <div className="col-lg-12 mt-3">
                <div className="card-wrapper card-space">
                  <div className="card card-bg no-after card-big roundedCustom">
                    <div className="etichetta">
                      <svg className="icon icon-primary">
                        <use href={`${iconSprite}#it-pencil`}></use>
                      </svg>
                      <span>
                        <a
                          className="text-decoration-none"
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            showModify(cartellaSociale);
                          }}
                        >
                          Modifica
                        </a>
                      </span>
                    </div>

                    <div className="card-body">
                      <h4>Dati integrativi cartella sociale</h4>
                      <div className="col-lg-12">
                        Medico curante:{" "}
                        <strong>
                          {cartellaSociale?.medico
                            ? "Dott./Dott.ssa " + cartellaSociale?.medico
                            : "N/D"}
                        </strong>
                      </div>
                      <div className="row">
                        <div className="col-lg-4 p-3">
                          IBAN: <strong>{cartellaSociale?.iban || ""}</strong>
                        </div>
                        <div className="col-lg-4 p-3">
                          Cittadinanza Italiana:{" "}
                          <strong>
                            {cartellaSociale?.cittadinanzaItaliana === true
                              ? "Sì"
                              : cartellaSociale?.cittadinanzaItaliana === false
                                ? "No"
                                : "N/D"}
                          </strong>
                        </div>
                        <div className="col-lg-4 p-3">
                          Altra Cittadinanza:{" "}
                          <strong>
                            {cartellaSociale?.altraCittadinanza === true
                              ? "Sì"
                              : cartellaSociale?.altraCittadinanza === false
                                ? "No"
                                : "N/D"}
                          </strong>
                        </div>
                        <div className="col-lg-4 p-3">
                          Possesso Permesso Soggiorno:{" "}
                          <strong>
                            {cartellaSociale?.possessoPermessoSoggiorno === true
                              ? "Sì"
                              : cartellaSociale?.possessoPermessoSoggiorno ===
                                  false
                                ? "No"
                                : "N/D"}
                          </strong>
                        </div>
                        <div className="col-lg-4 p-3">
                          Possesso Carta Soggiorno:{" "}
                          <strong>
                            {cartellaSociale?.possessoCartaSoggiorno === true
                              ? "Sì"
                              : cartellaSociale?.possessoCartaSoggiorno ===
                                  false
                                ? "No"
                                : "N/D"}
                          </strong>
                        </div>

                        <div className="col-lg-4 p-3">
                          Stato Civile:{" "}
                          <strong>
                            {cartellaSociale.statoCivileDescrizione}
                          </strong>
                        </div>

                        {cartellaSociale?.user?.homeAddress && ( // Verifica se homeAddress non è vuoto/null/undefined
                          <div className="col-lg-12 p-3">
                            Domicilio:{" "}
                            <strong>{cartellaSociale.user.homeAddress}</strong>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <nav>
                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                  <a
                    className={`nav-item nav-link ${
                      activeTab === "nav-tab1" ? "active" : ""
                    }`}
                    id="nav-tab1-tab"
                    onClick={() => handleTabClick("nav-tab1")}
                  >
                    Nucleo familiare
                  </a>
                  <a
                    className={`nav-item nav-link ${
                      activeTab === "nav-tab2" ? "active" : ""
                    }`}
                    id="nav-tab2-tab"
                    onClick={() => handleTabClick("nav-tab2")}
                  >
                    Familiari non residenti
                  </a>
                  <a
                    className={`nav-item nav-link ${
                      activeTab === "nav-tab3" ? "active" : ""
                    }`}
                    id="nav-tab3-tab"
                    onClick={() => handleTabClick("nav-tab3")}
                  >
                    Altri familiari
                  </a>
                </div>
                {/* Contenuto delle tab */}
                <div className="tab-content" id="nav-tabContent">
                  <div
                    className={`tab-pane fade ${
                      activeTab === "nav-tab1" ? "show active" : ""
                    }`}
                    id="nav-tab1"
                    role="tabpanel"
                    aria-labelledby="nav-tab1-tab"
                  >
                    <ComponentiNucleoFamiliareComponent
                      componentiNucleoFamiliare={componenteNucleoFamiliare}
                      userId={cartellaSociale.userId}
                      titolo="Componente nucleo familare residente"
                      nucleo="F"
                      cartellaSocialeId={cartellaSociale.id}
                    />
                  </div>
                  <div
                    className={`tab-pane fade ${
                      activeTab === "nav-tab2" ? "show active" : ""
                    }`}
                    id="nav-tab2"
                    role="tabpanel"
                    aria-labelledby="nav-tab2-tab"
                  >
                    <ComponentiNucleoFamiliareComponent
                      componentiNucleoFamiliare={
                        componenteNucleoFamiliareNonConviventi
                      }
                      userId={cartellaSociale.userId}
                      cartellaSocialeId={cartellaSociale.id}
                      titolo="Componente nucleo familare NON residente"
                      nucleo="N"
                    />
                  </div>
                  <div
                    className={`tab-pane fade ${
                      activeTab === "nav-tab3" ? "show active" : ""
                    }`}
                    id="nav-tab3"
                    role="tabpanel"
                    aria-labelledby="nav-tab3-tab"
                  >
                    <ComponentiNucleoFamiliareComponent
                      componentiNucleoFamiliare={
                        componenteNucleoFamiliareParente
                      }
                      userId={cartellaSociale.userId}
                      cartellaSocialeId={cartellaSociale.id}
                      titolo="Altri componenti del nucleo di origine"
                      nucleo="P"
                    />
                  </div>
                </div>
              </nav>

              {fiscalCode && (
                <AllegatiUtenteComponent
                  fiscalcode={fiscalCode}
                  userId={cartellaSociale.userId}
                />
              )}

              <CondizioniAbitativeComponent
                condizioniAbitative={condizioniAbitative}
                cartellaSocialeId={cartellaSociale.id}
              />

              <AnamnesiFamiliariComponent
                anamnesiFamiliari={anamnesiFamiliari}
                cartellaSocialeId={cartellaSociale.id}
              />

              <DiarioDiBordoComponent
                diarioDiBordo={diarioDiBordo}
                cartellaSocialeId={cartellaSociale.id}
              />
            </>
          )}
          {numberCard === 2 && (
            <div className="col-lg-12 ">
              <div className="card-wrapper card-space">
                <div className="card card-bg no-after card-big roundedCustom">
                  <div className="card-body">
                    <h5>Importa ISEE da INPS</h5>

                    <div className="mb-3">
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          id="radioData"
                          value="data"
                          checked={searchMode === "data"}
                          onChange={() => setSearchMode("data")}
                        />
                        <label className="form-check-label" htmlFor="radioData">
                          Per data
                        </label>
                      </div>

                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          id="radioDsu"
                          value="dsu"
                          checked={searchMode === "dsu"}
                          onChange={() => setSearchMode("dsu")}
                        />
                        <label className="form-check-label" htmlFor="radioDsu">
                          Per protocollo DSU
                        </label>
                      </div>
                    </div>

                    <div className="form-group">
                      {searchMode === "data" ? (
                        <Input
                          id="iseeReferenceDate"
                          type="date"
                          value={iseeDate}
                          onChange={(e) => setIseeDate(e.target.value)}
                        />
                      ) : (
                        <Input
                          id="protocolloDSU"
                          type="text"
                          placeholder="INPS-ISEE-2026-XXXXXXXX"
                          value={protocolloDSU}
                          onChange={(e) => setProtocolloDSU(e.target.value)}
                        />
                      )}
                    </div>

                    <div className="text-right mt-3">
                      <button
                        type="button"
                        className="btn btn-outline-primary"
                        onClick={() =>
                          searchMode === "data"
                            ? importaIseeDaInps()
                            : importaIseeDaInpsByDsu()
                        }
                        disabled={
                          loading ||
                          (searchMode === "data" && !iseeDate) ||
                          (searchMode === "dsu" && !protocolloDSU.trim())
                        }
                      >
                        Importa
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card-wrapper card-space">
                <div className="card card-bg no-after card-big roundedCustom">
                  <div className="etichetta">
                    <svg className="icon icon-primary">
                      <use href={`${iconSprite}#it-plus`}></use>
                    </svg>
                    <span>
                      {" "}
                      <a
                        className="text-decoration-none"
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          uploadIsee(query.get("id"));
                        }}
                      >
                        Aggiungi
                      </a>
                    </span>
                  </div>

                  <div className="card-body">
                    <div className="row my-2">
                      <div className="col-lg-9">
                        <h5>
                          ISEE{" "}
                          <i>
                            {user && user.firstName
                              ? " " + user.lastName + " " + user.firstName
                              : ""}
                          </i>
                        </h5>
                      </div>
                    </div>
                    {userIseesTemp && userIseesTemp.length > 0 ? (
                      <div className="row">
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              <th scope="col">Valore ISEE caricato</th>
                              <th scope="col">Data inserimento</th>
                              <th scope="col">Stato</th>
                              <th>Anno</th>
                              <th>Protocollo</th>
                              <th scope="col"></th>
                            </tr>
                          </thead>
                          <tbody>
                            {userIsees &&
                              userIsees.length > 0 &&
                              userIsees.map((y, index) => (
                                <tr key={index} index={index}>
                                  <th scope="row">
                                    {y.value &&
                                      parseFloat(y.value).toLocaleString(
                                        "it-IT",
                                      )}{" "}
                                    €
                                  </th>
                                  <td>{y.date}</td>
                                  <td>
                                    {y.state == "VALIDATED" ? (
                                      <>
                                        <b className="text-success">
                                          <svg className="icon icon-success">
                                            <use
                                              href={`${iconSprite}#it-check-circle`}
                                            />
                                          </svg>{" "}
                                          ACCETTATO
                                        </b>
                                      </>
                                    ) : y.state == "LOADED" ? (
                                      <b className="">
                                        <svg className="icon">
                                          <use
                                            href={`${iconSprite}#it-close-circle`}
                                          />
                                        </svg>
                                        DA VERIFICARE
                                      </b>
                                    ) : y.state == "REFUSED" ? (
                                      <b className="text-danger">
                                        <svg className="icon icon-danger">
                                          <use
                                            href={`${iconSprite}#it-close-circle`}
                                          />
                                        </svg>{" "}
                                        RIFIUTATO
                                      </b>
                                    ) : (
                                      <b className="text-danger">
                                        <svg className="icon icon-danger">
                                          <use
                                            href={`${iconSprite}#it-close-circle`}
                                          />
                                        </svg>{" "}
                                        {y.state}
                                      </b>
                                    )}
                                  </td>
                                  <td>{y.year}</td>
                                  <td>{y.numeroProtocollo || "-"}</td>
                                  <td className="text-right">
                                    {y.state == "LOADED" ? (
                                      <Link
                                        to={
                                          "/lista_utenti/cartella_sociale/verifica_isee?idIsee=" +
                                          y.id
                                        }
                                      >
                                        <button
                                          className="btn btn-outline-primary p-2"
                                          data-toggle="tooltip"
                                          data-placement="top"
                                          title="Dettaglio"
                                        >
                                          <svg className="icon icon-primary">
                                            <use
                                              href={`${iconSprite}#it-search`}
                                            />
                                          </svg>
                                        </button>
                                      </Link>
                                    ) : (
                                      <Link
                                        to={
                                          "/lista_utenti/cartella_sociale/visualizza_isee?idIsee=" +
                                          y.id
                                        }
                                      >
                                        <button
                                          className="btn btn-outline-primary p-2"
                                          data-toggle="tooltip"
                                          data-placement="top"
                                          title="Dettaglio"
                                        >
                                          <svg className="icon icon-primary">
                                            <use
                                              href={`${iconSprite}#it-search`}
                                            />
                                          </svg>
                                        </button>
                                      </Link>
                                    )}
                                    <button
                                      className="btn btn-outline-danger p-2 ml-1"
                                      type="button"
                                      data-toggle="tooltip"
                                      data-placement="top"
                                      title="Elimina"
                                      onClick={() => handleDelete(y.id)}
                                    >
                                      <svg className="icon icon-danger">
                                        <use href={`${iconSprite}#it-delete`} />
                                      </svg>
                                    </button>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                        {user.isees && (
                          <Pagination
                            items={userIseesTemp}
                            setCurrentItems={setUserIsees}
                            itemsPerPage={5}
                          ></Pagination>
                        )}
                      </div>
                    ) : (
                      <>Non sono presenti ISEE per questo utente</>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
          {numberCard === 3 && (
            <>
              <UserSubscriptionsComponent
                user={cartellaSociale.user}
                userSubscriptionsTemp={userSubscriptionsTemp}
                userSubscriptions={userSubscriptionsTemp}
                setUserSubscriptions={userSubscriptionsTemp}
              />

              <InterventiSocioAssistenzialiComponent
                isExecutive={props.isExecutive}
                cartellaSociale={cartellaSociale}
                bandiAttivabili={bandiAttivabili}
              ></InterventiSocioAssistenzialiComponent>
            </>
          )}
          {numberCard === 4 && (
            <ListPaymemtsUsers
              payments={payments}
              paymentsTemp={paymentsTemp}
              setPayments={setPayments}
              fiscalCode={true}
              userId={paramId}
            />
          )}
          <ModalComponent
            toggleModal={toggleModalModify}
            isOpen={showModalModify}
            header="Modifica dati integrativi cartella sociale"
            body={bodyModify()}
            buttonDeny="Chiudi"
            onClose={handleCloseModalModify}
          />
          <ModalComponent
            toggleModal={toggleModalAnprLogs}
            isOpen={isOpenAnprLogs}
            header={
              user
                ? `Changelog ANPR: ${user.firstName} ${user.lastName}`
                : "Changelog ANPR"
            }
            body={anprLogsBody()}
            buttonDeny="Chiudi"
            size="xl"
          />
        </div>
        {loading && <Loader></Loader>}
      </div>
    </>
  );
}

export default ViewCartellaSociale;
